import {qspost} from '@/plugins/axios'

/*
 * 专家—当前可评估的列表
 * @constructor jack
 * */
export const getScoreList = () => qspost('/index/index/index', {})

/*
 * 专家—当前可评估的机构列表
 * @constructor jack
 * */
export const getOrgList = (id,searchName) => qspost('/index/index/orgList', {id,searchName})

/*
 * 专家—当前可评估的机构信息
 * @constructor jack
 * */
export const getInfo = (org_id,playing_id) => qspost('/index/index/other', {org_id,playing_id})

/*
 * 专家—当前可评估的机构 一级打分表
 * @constructor jack
 * */
export const getFristInfo = (org_id,playing_id) => qspost('/index/index/assessmentList', {org_id,playing_id})

/*
 * 专家—当前可评估的机构 获取二三级级打分表
 * @constructor jack
 * */
export const getTwoInfo = (org_id,playing_id,id) => qspost('/index/index/playList', {org_id,playing_id,id})


/*
 * 专家—当前可评估的机构 获取四级打分表
 * @constructor jack
 * */
export const getThreeInfo = (org_id,playing_id,id) => qspost('/index/index/playFourList', {org_id,playing_id,id})

/*
 * 专家—当前可评估的机构 获取四级打分表详情
 * @constructor jack
 * */
export const getFourDetial = (id) => qspost('/index/index/getAffiliatedContent', {id})

/*
 * 专家—当前可评估的机构 保存四级打分表详情
 * @constructor jack
 * */
export const saveFourScore = (org_id,indicators_id,id,score,remark) => qspost('/index/index/setScore', {org_id,indicators_id,id,score,remark})

/*
 * 专家—当前可评估的机构 栏目总分计算
 * @constructor jack
 * */
export const calculateTotalScore = (org_id,playing_id,id) => qspost('/index/index/calculateTotalScore', {org_id,playing_id,id})



/*
 * 专家—当前可评估的机构 栏目总分计算
 * @constructor jack
 * */
export const getUserList = () => qspost('/index/expert/index', {})


/*
* 专家—当前可评估的机构 栏目总分计算
* @constructor jack
* */
export const electronicSign = (org_id,indicators_id,file) => qspost('/index/index/electronicSign', {org_id,indicators_id,file})


